import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const SmileyHappy: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m390 660c-72.12 0-139.92-28.08-190.92-79.08s-79.08-118.8-79.08-190.92 28.08-139.92 79.08-190.92 118.8-79.08 190.92-79.08 139.92 28.08 190.92 79.08 79.08 118.8 79.08 190.92-28.08 139.92-79.08 190.92-118.8 79.08-190.92 79.08zm0-510c-64.11 0-124.38 24.96-169.71 70.29s-70.29 105.6-70.29 169.71 24.96 124.38 70.29 169.71 105.6 70.29 169.71 70.29 124.38-24.96 169.71-70.29 70.29-105.6 70.29-169.71-24.96-124.38-70.29-169.71-105.6-70.29-169.71-70.29z' />
    <circle cx='300' cy='330' r='30' />
    <circle cx='480' cy='330' r='30' />
    <path d='m390 570c-66.17 0-120-47.1-120-105v-15h240v15c0 57.9-53.83 105-120 105zm-88.19-90c8.36 34.19 44.73 60 88.19 60s79.83-25.81 88.19-60z' />
  </IconBase>
));

SmileyHappy.displayName = 'SmileyHappy';

export default SmileyHappy;
